var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_22188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.65002H15V5.15002C14.9993 4.55349 14.7621 3.98157 14.3403 3.55976C13.9185 3.13794 13.3465 2.90068 12.75 2.90002H11.1504C10.7897 2.90147 10.4415 3.03224 10.169 3.26857C9.89652 3.50491 9.71783 3.83113 9.6654 4.188L9.03142 8.62537L6.3486 12.65H1.5V23.15H17.25C18.6419 23.1485 19.9764 22.5949 20.9606 21.6106C21.9448 20.6264 22.4985 19.2919 22.5 17.9V12.65C22.4991 11.8546 22.1828 11.0921 21.6203 10.5297C21.0579 9.96728 20.2954 9.65092 19.5 9.65002ZM6 21.65H3V14.15H6V21.65ZM21 17.9C20.9989 18.8942 20.6034 19.8474 19.9004 20.5504C19.1974 21.2534 18.2442 21.6489 17.25 21.65H7.5V13.627L10.4683 9.17467L11.1504 4.40002H12.75C12.9489 4.40018 13.1395 4.47925 13.2802 4.61987C13.4208 4.76049 13.4998 4.95116 13.5 5.15002V11.15H19.5C19.8977 11.1505 20.2789 11.3087 20.5601 11.5899C20.8413 11.8711 20.9995 12.2524 21 12.65V17.9Z",
    fill: "#29CC39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_22188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.650024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeThumb);
export default __webpack_public_path__ + "static/media/likeThumb.9a606d9b2cee8d3bde2a6b4689121a50.svg";
export { ForwardRef as ReactComponent };